import gql from "graphql-tag";

export const createProject = gql`
  mutation createProject(
    $title: String!
    $segmentId: ID!
    $countryId: ID!
    $cityId: ID!
    $year: Int
    $marketId: ID
    $instances: [ID]!
    $products: [ID]
    $applicationEn: String
    $applicationEs: String
    $applicationByUser: String
  ) {
    projectBasicData(
      title: $title
      segmentId: $segmentId
      countryId: $countryId
      cityId: $cityId
      year: $year
      marketId: $marketId
      instances: $instances
      products: $products
      applicationEn: $applicationEn,
      applicationEs: $applicationEs
      applicationByUser: $applicationByUser
    ) {
      project {
        id
        title
      }
      createdBy
    }
}
`;

export const updateProjectInformation = gql`
  mutation updateProjectInformation(
    $projectId: ID!
    $title: String
    $instances: [ID]
    $segmentId: ID
    $products: [ID]
    $marketId: ID
    $countryId: ID
    $cityId: ID
    $year: Int
    $salesMember: [ID]
    $invoicedTo: [ID],
    $specifiedBy: [ID],
    $manufacturer: [ID],
    $selledMts: Int
    $authorization: String,
    $authorizationByClient: String,
    $creditsForImages: String,
    $authorizationFile: String,
    $applicationEn: String,
    $applicationEs: String,
    $applicationByUser: String
    $imagePaths: [String]
    $mainImagePath: String
    $finalClient: [ID]
    $declarationOfUse: Boolean
    $unitOfMeasure: String
  ) {
    updateProjectData(
      projectId: $projectId
      title: $title
      instances: $instances
      segmentId: $segmentId
      products: $products
      marketId: $marketId
      countryId: $countryId
      cityId: $cityId
      year: $year
      salesMember: $salesMember
      invoicedTo: $invoicedTo
      specifiedBy: $specifiedBy
      manufacturer: $manufacturer
      selledMts: $selledMts
      authorization: $authorization
      authorizationByClient: $authorizationByClient
      creditsForImages: $creditsForImages
      authorizationFile: $authorizationFile
      applicationEn: $applicationEn
      applicationEs: $applicationEs
      applicationByUser: $applicationByUser
      imagePaths: $imagePaths
      mainImagePath: $mainImagePath
      finalClient: $finalClient
      declarationOfUse: $declarationOfUse
      unitOfMeasure: $unitOfMeasure
    ) {
      project{
        id
        title
        comments {
          edges {
            node {
              id
              comment
              sentBy {
                fullName
              }
              createdAt
              status
              deleted
            }
          }
        }
      }
      updatedBy
      ok
    }
  }
`;  